import React from 'react';
import { Button } from './Button';
export function PersuasiveCTA() {
  return <section className="py-8 md:py-12 px-4 bg-brand-card" data-id="element-176">
      <div className="max-w-2xl mx-auto" data-id="element-177">
        <Button className="text-xl md:text-2xl py-4 md:py-5" pulse={true} data-id="element-178">
          ⚡ SÍ, QUIERO DEJAR DE IMPROVISAR →
        </Button>
      </div>
    </section>;
}